module.exports = __webpack_public_path__ + "static/media/icn-loader.d40c05c8.gif";